/*
 * Copyright (c) Nexign, JSC, 2021-2023.
 */
/**
 * Page SubscriberId component styles
 *
 * @author Yakov Gushchin
 * @author Evgeniy Naumov
 * @version 1.25.1
 * @since 1.12.0
 */

import styled from 'styled-components';

import { colors, fonts } from '@/main/theme/index';
import { IAttrStyled } from '@/main/types/globalTypes';

export const PageSubscriberIdDateStyled = styled.div.attrs({
    className: 'page-account-info__sync-date',
})`
    display: flex;
    align-items: center;
    ${fonts.textMain};
    color: ${colors.textColorOpacity};
    gap: 6px;
`;

export const PageSubscriberIdTitleStyled = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
`;

export const PageSubscriberIdStyled = styled.div.attrs({
    className: 'subscriber',
})`
    display: grid;
    grid-template-columns: 283px calc(100% - 283px);
    grid-template-rows: auto 1fr;
    height: 100%;

    .error-page {
        grid-column-start: 1;
        grid-column-end: 3;

        margin-bottom: 32px;
    }

    .subscriber__title {
        grid-column-start: 1;
        grid-column-end: 3;

        ${fonts.textHeader3};
        margin-bottom: 16px;
    }

    .subscriber__side-menu {
        display: flex;
        flex-direction: column;
        min-height: 500px;
        border-top: 1px solid ${colors.borderColorDisabled};
        border-right: 1px solid ${colors.borderColorDisabled};
    }

    .subscriber__content {
        position: relative;
        margin-bottom: 86px;
        border-top: 1px solid ${colors.borderColorDisabled};

        .subscriber__wrapper {
            padding: 32px;
        }

        /* TITLE */

        .subscriber-id__title {
            margin-bottom: 4px;

            &.subscriber-id__title_light {
                color: ${colors.textColorOpacity};
            }

            &.subscriber-id__title_bold {
                ${fonts.textMainBold};
            }
        }
    }
`;

export const SubscriberIdSkeletonStyled = styled.div.attrs(({ className }: IAttrStyled) => ({
    className: `subscriber-id__skeleton ${className || ''}`,
}))<IAttrStyled>`
    & .skeleton__paragraph {
        margin-bottom: 8px;
    }

    & .skeleton__paragraph:last-child {
        margin-bottom: 24px;
    }
`;
